/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".rootIsFixed_c6c9a9fe{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_c6c9a9fe{visibility:visible}\n"}]);
export const rootIsFixed = "rootIsFixed_c6c9a9fe";
export const content = "content_c6c9a9fe";